<script lang="ts" setup>
import { ChevronRight } from 'lucide-vue-next'
import type { HTMLAttributes } from 'vue'
import { cn } from '@/foundation/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <li role="presentation" aria-hidden="true" :class="cn('[&>svg]:w-3.5 [&>svg]:h-3.5', props.class)">
    <slot>
      <ChevronRight />
    </slot>
  </li>
</template>
